import angular from "angular";

angular
    .module('app')
    .component('attachedStudentsModal', {
        template: require('./attached-students-modal.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', '$scope', 'moment', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier, $scope, moment) {

    let $ctrl = this;

    $ctrl.page = 1;

    $ctrl.search = null;

    $ctrl.totalSelect = false;

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;
        $ctrl.group = $ctrl.resolve.group;
        $ctrl.students = $ctrl.resolve.students;

    };

    function delStudentFromSelected(student) {
        let existsInd = $ctrl.students.findIndex(v => v.id == student.id);
        if (existsInd != -1) {
            $ctrl.students.splice(existsInd, 1);
        }
    }

    $ctrl.delSelectedStudent = function (student) {
        student.isSelected = false;
        delStudentFromSelected(student);
    };

    $ctrl.submit = function () {

        let ids = [];

        $ctrl.students.forEach(v => ids.push(v.id));

        $ctrl.loading = true;

        $http
            .post(`/admin/courses/${$ctrl.course.id}/groups/${$ctrl.group.id}/attach-students`, {user_ids: ids})
            .then(
                function (response) {
                    $ctrl.loading = false;
                    Notifier.success('Студенты успешно добавлены', 3);
                    $ctrl.close($ctrl.students);
                },
                function (error) {
                    $ctrl.loading = false;
                    ErrorResponseParser.parse(error);
                }
            );
    };

}
